import React from 'react';
import FinancialWidget from '../components/FinancialWidget';
import { monitoringConfig } from '../common/monitoringConfig';
import MetalBidWidget from 'widgets/allmetals-mini-expanded-bid-widget';
import CommodityWidget from 'widgets/WidgetTableView';
import CompactGoldPriceWidget from 'widgets/super-mini-gold-price-widget';
import SpotPriceWidget from 'widgets/SpotPriceWidget';
import LondonFixWidget from 'widgets/LondonFixWidget';
import CrossRatesTable from 'widgets/KitcoCrossRatesWidget';
import ThreeDayChartWidget from 'widgets/ThreeDayChartWidget';
import NYChartsWidget from 'widgets/NYChartsWidget';
import PreciousMetalsWidget from 'widgets/PreciousMetalsWidget';
import BaseMetalsChartsWidget from 'widgets/BaseMetalsChartsWidget';
import KitcoBrandedMetalPerformance from 'widgets/KitcoBrandedMetalPerformance';
import MetalPriceWidget from 'widgets/preciousmetals-price-pefromance-widget (1)';
import NewsWidget from 'widgets/NewsWidget';
import FinalKitcoPriceCalculator from 'widgets/CalculatorWidget';
import KitcoFinancialTicker from 'widgets/KitcoFinancialTicker';
import { logoUrl } from 'common/constants';
import { useNavigate } from 'react-router-dom';

function MonitoringWidgets() {
  const navigate = useNavigate();
  return (
    <div className='py-6 px-2 lg:px-[40px]'>
      <div className='text-[16px]'>
         <img
          src={logoUrl.light} 
          alt="logo"
          className='h-[30px] cursor-pointer'
          onClick={() => navigate('/')}
        /> 
      </div>
      <div className='flex space-x-2 space-y-6 lg:space-y-4 flex-wrap justify-center lg:justify-start'>
        <div className='pt-4'>
          {monitoringConfig.financialKgx && (
            <FinancialWidget config={monitoringConfig.financialKgx} />
          )}
        </div>
        <div className='space-y-4 lg:space-y-2'>
          <div>
            {monitoringConfig.compactPrice && (
              <MetalBidWidget config={monitoringConfig.compactPrice} />
            )}
          </div>
          <div>
          {monitoringConfig.goldBid && (
            <CompactGoldPriceWidget config={monitoringConfig.goldBid} />
          )}
        </div>

        </div>
        <div>
          {monitoringConfig.commodityTable && (
            <CommodityWidget config={monitoringConfig.commodityTable} />
          )}
        </div>
        <div>
          {monitoringConfig.spotPrice && (
            <SpotPriceWidget config={monitoringConfig.spotPrice} />
          )}
        </div>
        <div>
          {monitoringConfig.londonFix && (
            <LondonFixWidget config={monitoringConfig.londonFix} />
          )}
        </div>
        <div>
          {monitoringConfig.calculator && (
            <FinalKitcoPriceCalculator config={monitoringConfig.calculator} />
          )}
        </div>
        <div>
          {monitoringConfig.threeDaysCharts && (
            <ThreeDayChartWidget config={monitoringConfig.threeDaysCharts} />
          )}
        </div>
        <div>
          {monitoringConfig.NYChart && (
            <NYChartsWidget config={monitoringConfig.NYChart} />
          )}
        </div>
        <div>
          {monitoringConfig.preciousMetalsChart && (
            <PreciousMetalsWidget
              config={monitoringConfig.preciousMetalsChart}
            />
          )}
        </div>
        <div>
          {monitoringConfig.baseMetalsCharts && (
            <BaseMetalsChartsWidget
              config={monitoringConfig.baseMetalsCharts}
            />
          )}
        </div>
        <div>
          {monitoringConfig.crossRates && (
            <CrossRatesTable config={monitoringConfig.crossRates} />
          )}
        </div>
        <div>
          {monitoringConfig.brandedMetalPerformance && (
            <KitcoBrandedMetalPerformance
              config={monitoringConfig.brandedMetalPerformance}
            />
          )}
        </div>
        <div>
          {monitoringConfig.metalPricePerformance && (
            <MetalPriceWidget config={monitoringConfig.metalPricePerformance} />
          )}
        </div>
           <div className='relative'>
            {monitoringConfig.news && (
              <NewsWidget config={monitoringConfig.news} />
            )}
          </div> 
        <div>
          {monitoringConfig.ticker && (
            <KitcoFinancialTicker config={monitoringConfig.ticker} />
          )}
        </div>
      </div>
      
    </div>
  );
}

export default MonitoringWidgets;
